import { useState, useEffect, useCallback } from 'react';
import {
  fetchNotificacoes,
  fetchNotificacoesNaoLidasCount,
  marcarComoLida as apiMarcarLida,
  deletarNotificacao as apiDeletarNotificacao,
  deletarTodasNotificacoes as apiDeletarTodas,
} from '../api/notificacoes';

export function useNotificacoes() {
  const [lista, setLista] = useState([]);
  const [countNaoLidas, setCountNaoLidas] = useState(0);
  const [loading, setLoading] = useState(false);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const [notifs, count] = await Promise.all([fetchNotificacoes(), fetchNotificacoesNaoLidasCount()]);
      setLista(notifs);
      setCountNaoLidas(count);
    } catch (_) {
      setLista([]);
      setCountNaoLidas(0);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
    const t = setInterval(load, 60000);
    return () => clearInterval(t);
  }, [load]);

  const marcarComoLida = useCallback(async (id) => {
    await apiMarcarLida(id);
    setLista((prev) => prev.map((n) => (n.id === id ? { ...n, lida: 1 } : n)));
    setCountNaoLidas((c) => Math.max(0, c - 1));
  }, []);

  const removerNotificacao = useCallback(async (id) => {
    const removerDaLista = () => {
      setLista((prev) => {
        const item = prev.find((n) => n.id === id);
        const nova = prev.filter((n) => n.id !== id);
        if (item && !item.lida) setCountNaoLidas((c) => Math.max(0, c - 1));
        return nova;
      });
    };
    try {
      await apiDeletarNotificacao(id);
      removerDaLista();
    } catch (_) {
      removerDaLista();
    }
  }, []);

  const removerVarias = useCallback(async (ids) => {
    const setIds = new Set(ids);
    const removidos = lista.filter((n) => setIds.has(n.id));
    const qtdNaoLidas = removidos.filter((n) => !n.lida).length;
    try {
      await Promise.all(ids.map((id) => apiDeletarNotificacao(id)));
    } catch (_) {}
    setLista((prev) => prev.filter((n) => !setIds.has(n.id)));
    setCountNaoLidas((c) => Math.max(0, c - qtdNaoLidas));
  }, [lista]);

  const removerTodas = useCallback(async () => {
    try {
      await apiDeletarTodas();
    } catch (_) {}
    setLista([]);
    setCountNaoLidas(0);
  }, []);

  return {
    lista,
    countNaoLidas,
    loading,
    marcarComoLida,
    refetch: load,
    removerNotificacao,
    removerVarias,
    removerTodas,
  };
}
